const it = {
    user: {
        title: 'Utenti',
        subTitle: 'Gestione utenti',
        labelUser: 'Utente',
        count: 'Utenti: ',
        label: 'Nominativo',
        inserData: 'Inserisci i dati',
        tabName: {
            listUser: 'Utenti',
            createUser: 'Crea Utente',
        },

        USER: {
            title: 'Lista utenti',
            subTitle: 'Elenco utenti',
            count: 'Utenti: ',
        },
        changeImage: 'Cambia immagine',
        changeImageUrl: 'Cambia l\'immagine del tuo profilo da qui',
        noData: 'Nessun nominativo trovato',
        email: 'Email',
        userData: 'Dati utente',
        userDataChange: 'Per aggiornare i tuoi dati utente procedi qui',
        userDisplayName: 'Nominativo',
        imageUrl: 'Immagine profilo',
        companyCode: 'Matricola',
        accessLink: 'Link accesso',
        role: 'Ruolo',
        mobile: 'Telefono',
        roleDescription: {
            ADMIN: 'Amministratore',
            TEAMLEADER: 'Gestore',
            USER: 'Utente',
            SUPERADMIN: 'Super Amministratore',
            GUEST: 'Ospite',
            KIOSK: 'Chiosco',
        },
        errorCallApi: 'Errore durante la chiamata al server',
    },
}
export default it
